import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { NotificationDetailsComponent } from "./notification-details/notification-details.component";
import { NotificationUpdateComponent } from "./notification-update/notification-update.component";

export const NOTIFICATION_ROUTES: Routes = [
  {
    path: 'notification/details/:prid/:jobid/:notid',
    component: NotificationDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'notification/update/:prid/:jobid/:notid',
    component: NotificationUpdateComponent,
    canActivate: [authGuard]
  },
];
